import type { ExperimentalHero } from './types';
import type { LanderExperiment } from './assignment';
import type { LandingPageType } from '../landingPage';

// IDs identify immutable renderers, never their current role in an experiment.
export const LANDERS: Record<string, () => Promise<ExperimentalHero | undefined>> = {
  // Same hero as v1, with the Jacob's Ladder branding in AppIcon.
  'stories-phone-library-v2': async () => (await import('./phoneLibrary')).phoneLibraryHero,
  'stories-phone-library-v1': async () => (await import('./phoneLibrary')).phoneLibraryHero,
  'stories-phone-v1': async () => undefined,
  'stories-video-cards-v1': async () => (await import('./videoCards')).videoCardsHero,
  // Bundled, not lazy: it is a single string and must not add a request before the hero renders.
  'stories-animated-subtitle-v1': async () => ({subtitle: 'Animated videos of bible stories everyone should know'}),
  'stories-animated-stars-v1': async () => (await import('./starsHero')).starsHero,
};
// Root visitors see this lander whenever no experiment is active. Changing it is how a challenger is promoted.
export const DEFAULT_LANDER_ID = 'stories-phone-library-v2';
// The deployed build owns the experiment: visitors are split 50/50 in the browser and the choice is reported afterwards.
// Starting a test needs a new `stories-YYYYMMDD-NN` ID (New York date); set this to null to end it.
export const ACTIVE_EXPERIMENT: LanderExperiment | null = null;
export const PREVIEW_CHALLENGER_ID = 'stories-phone-library-v2';
// Named routes that reuse a lander's artwork under their own copy from App. They never enroll in an experiment.
export const ROUTE_ARTWORK: Partial<Record<LandingPageType, string>> = {animated: 'stories-phone-library-v2'};
